export const getUserAccessStatus = (user) => {
  const isPrivileged =
    user.isSuperAdmin ||
    /^\s*(?:admin|super_?admin)\s*$/i.test(String(user.role || "")) ||
    /^\s*(?:admin|super_?admin|supper|team)\s*$/i.test(
      String(user.adminType || "")
    );

  if (isPrivileged) {
    return { label: "Admin access", background: "#e8efff", color: "#3157b7" };
  }

  if (!user.emailVerified) {
    return { label: "Verification required", background: "#fff3dc", color: "#b56806" };
  }

  if (user.subscriptionAccessExempt) {
    return { label: "Bypass access", background: "#eeeaff", color: "#6d4aff" };
  }

  if (user.subscription) {
    return { label: "Subscription access", background: "#e8f8ee", color: "#15803d" };
  }

  if (user.freeAccessActive) {
    return { label: "Free-month access", background: "#fff3dc", color: "#b56806" };
  }

  return { label: "No access", background: "#f3f4f6", color: "#6b7280" };
};
